import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus, AccountInfo } from "@azure/msal-browser";

// Correct imports from default exports
import HomePage from "../pages/Super Admin/HomePage";
import LoginPage from "../pages/Super Admin/LoginPage";
import ReleaseAppointmentPage from "../pages/Super Admin/ReleaseAppointmentPage";
import AddStationsPage from "../pages/Super Admin/AddStationsPage";
import EditAppointmentPage from "../pages/Super Admin/EditAppointmentPage";
import EditLogPage from "../pages/Super Admin/EditLogPage";
import CenterDashboardPage from "../pages/Super Admin/CenterDashboardPage";
import FormsPage from "../pages/Super Admin/Formspage";
import RolesPage from "../pages/Super Admin/RolesPage";
import StationManagementPage from "../pages/Super Admin/StationManagementPage";
import CentersPage from "../pages/Super Admin/CentersPage";
import OnboardUsersPage from "../pages/Super Admin/OnBoardUsersPage";
import SlotDesignPage from "../pages/Super Admin/SlotDesignPage";
import FeeConfigPage from "../pages/Super Admin/FeeConfigPage";
import CouponCodePage from "../pages/Super Admin/CouponCodePage";
import RefundPage from "../pages/Super Admin/RefundPage";
import Profile from "../features/auth/Profile";
import LayoutWithSidebar from "../components/Super Admin/Layout/LayoutWithSidebar";
import PrivateRoute from "./PrivateRoute";
import SuperAdminRoute from "./SuperAdminRoute";
import { setAuthState } from "../features/auth/authSlice";
import ParentListPage from "../pages/Super Admin/ParentListPage";
import NotificationTemplatePage from "../pages/Super Admin/NotificationTempletPage";
import QueryInboxPage from "../pages/Super Admin/HelpdeskQueryListPage";
import QuestionnairePage from "../pages/Super Admin/QuestionnairePage";
import HistoricalQuestionsPage from "../pages/Super Admin/HistoricalQuestionsPage";
import EmrManagementPage from "../pages/Super Admin/EmrManagementPage";

import { AppLayout } from "../components/Center Admin/layout/AppLayout";
import WelcomeScreenView from "../pages/Center Admin/welcome_screen.view";
import { BnuSamplePage } from "../pages/Center Admin/BnuSamplePage";
// import { LabReportsPage } from '../pages/Center Admin/LabReportsPage';
import LabReportsEntry from "../pages/Center Admin/LabReportsEntry";
// import { NursePage } from "../pages/Center Admin/NursePage";
import Forms from "../pages/Center Admin/FormsPage";
import Nurse1DashboardApi from "../pages/Nurses/Nurse1/Nurse1DashboardApi";
import Nurse2DashboardApi from "../pages/Nurses/Nurse2/Nurse2DashboardApi";
import Nurse3DashboardApi from "../pages/Nurses/Nurse3/Nurse3DashboardApi";
import { Nurse1Page } from "../pages/Nurses/Nurse1/Nurse1Page";
import { Nurse2Page } from "../pages/Nurses/Nurse2/Nurse2Page";
import { Nurse3Page } from "../pages/Nurses/Nurse3/Nurse3Page";
import AudiologistDashboardPage from "../pages/Audiologist/AudiologistDashboardApi";
import AudiologistDashboardApi from "../pages/Audiologist/AudiologistDashboardApi";
import AudiologyScreeningPage from "../pages/Audiologist/AudiologyScreeningPage";
import OptometristDashboardApi from "../pages/Optometrist/OptometristDashboardApi";
import { VisionScreeningPage } from "../pages/Optometrist/VisionScreeningPage";
import CheckInView from "../pages/Center Admin/checkin.view";
import GrowthChartScreen from "../pages/Center Admin/GrowthChartEntry";
import LabPickupPage from "../pages/Center Admin/LabPickupPage";
import WelcomeScreenPage from "../pages/Center Admin/WelcomeScreenPage"; // Adjust path if needed
import CheckInPage from "../pages/Center Admin/CheckInPage";
import NewDashboardPage from "../pages/Center Admin/NewDashboardPage";

export const AppRoutes = () => {
  const dispatch = useDispatch();
  const { accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (accounts.length > 0 && inProgress === InteractionStatus.None) {
      const account = accounts[0] as AccountInfo;
      dispatch(setAuthState({ isAuthenticated: true, account: account }));
    } else if (!isAuthenticated && inProgress === InteractionStatus.None) {
      dispatch(setAuthState({ isAuthenticated: false, account: null }));
    }
  }, [isAuthenticated, inProgress, accounts, dispatch]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<PrivateRoute component={HomePage} />} />
      <Route path="/profile" element={<PrivateRoute component={Profile} />} />

      <Route element={<LayoutWithSidebar />}>
        <Route path="/forms" element={<PrivateRoute component={FormsPage} />} />
        <Route path="/roles" element={<PrivateRoute component={RolesPage} />} />
        <Route
          path="/stations"
          element={<PrivateRoute component={StationManagementPage} />}
        />
        <Route
          path="/centers"
          element={<PrivateRoute component={CentersPage} />}
        />
        <Route
          path="/users"
          element={<PrivateRoute component={OnboardUsersPage} />}
        />
        <Route
          path="/slots"
          element={<PrivateRoute component={SlotDesignPage} />}
        />
        <Route
          path="/release-appointment"
          element={<PrivateRoute component={ReleaseAppointmentPage} />}
        />
        <Route
          path="/add-stations"
          element={<PrivateRoute component={AddStationsPage} />}
        />
        <Route
          path="/edit-appointment"
          element={<PrivateRoute component={EditAppointmentPage} />}
        />
        <Route
          path="/edit-log"
          element={<PrivateRoute component={EditLogPage} />}
        />
        <Route
          path="/center-dashboard"
          element={<PrivateRoute component={CenterDashboardPage} />}
        />
        <Route
          path="/fee-tax"
          element={<PrivateRoute component={FeeConfigPage} />}
        />
        <Route
          path="/coupons"
          element={<PrivateRoute component={CouponCodePage} />}
        />
        <Route
          path="/refund"
          element={<PrivateRoute component={RefundPage} />}
        />

        <Route
          path="/parent-list"
          element={<PrivateRoute component={ParentListPage} />}
        />
        <Route
          path="/notification-templet"
          element={<PrivateRoute component={NotificationTemplatePage} />}
        />
        <Route
          path="/helpdesk"
          element={<PrivateRoute component={QueryInboxPage} />}
        />
        <Route
          path="/questionnaire"
          element={<PrivateRoute component={QuestionnairePage} />}
        />
        <Route
          path="/histories"
          element={<PrivateRoute component={HistoricalQuestionsPage} />}
        />
        <Route
          path="/emr-management"
          element={<PrivateRoute component={EmrManagementPage} />}
        />
      </Route>

      <Route element={<AppLayout />}>
        <Route
          path="/bnu-sample"
          element={<PrivateRoute component={BnuSamplePage} />}
        />
        {/* <Route path="/bnu-sample" element={<BnuSamplePage />} /> */}
        <Route
          path="/nurse-page"
          element={<PrivateRoute component={Forms} />}
        />
        {/* <Route path="/nurse-page" element={<NursePage />} /> */}
        <Route
          path="/nurse-1"
          element={<PrivateRoute component={Nurse1Page} />}
        />
        {/* <Route path="/nurse-1" element={<Nurse1Page />} /> */}
        <Route
          path="/nurse-2"
          element={<PrivateRoute component={Nurse2Page} />}
        />
        {/* <Route path="/nurse-2" element={<Nurse2Page />} /> */}
        <Route
          path="/nurse-3"
          element={<PrivateRoute component={Nurse3Page} />}
        />
        {/* <Route path="/nurse-3" element={<Nurse3Page />} /> */}
        <Route
          path="/audiology/dashboard"
          element={<PrivateRoute component={AudiologistDashboardApi} />}
        />
        {/* <Route path="/audiology/dashboard" element={<AudiologistDashboardApi />}/> */}
        <Route
          path="/nurse-1/dashboard"
          element={<PrivateRoute component={Nurse1DashboardApi} />}
        />
        {/* <Route path="/nurse-1/dashboard" element={<Nurse1DashboardApi />} /> */}
        <Route
          path="/nurse-2/dashboard"
          element={<PrivateRoute component={Nurse2DashboardApi} />}
        />
        {/* <Route path="/nurse-2/dashboard" element={<Nurse2DashboardApi />} /> */}
        <Route
          path="/nurse-3/dashboard"
          element={<PrivateRoute component={Nurse3DashboardApi} />}
        />
        {/* <Route path="/nurse-3/dashboard" element={<Nurse3DashboardApi />} /> */}
        <Route
          path="/audiology/screening"
          element={<PrivateRoute component={AudiologyScreeningPage} />}
        />
        {/* <Route  path="/audiology/screening"  element={<AudiologyScreeningPage />} /> */}
        <Route
          path="/vision-screening"
          element={<PrivateRoute component={VisionScreeningPage} />}
        />
        {/* <Route path="/vision-screening" element={<VisionScreeningPage />} /> */}
        <Route
          path="/optometrist/dashboard"
          element={<PrivateRoute component={OptometristDashboardApi} />}
        />
        {/* <Route  path="/optometrist/dashboard"  element={<OptometristDashboardApi />}  /> */}

        {/* Your routes */}
        <Route
          path="/welcome_screen"
          element={<PrivateRoute component={WelcomeScreenPage} />}
        />
        {/* <Route path="/welcome_screen" element={<WelcomeScreenPage />} /> */}
        <Route
          path="/check-view"
          element={<PrivateRoute component={CheckInPage} />}
        />
        {/* <Route path="/check-view" element={<CheckInPage />} /> */}
        <Route
          path="/growth-chart"
          element={<PrivateRoute component={GrowthChartScreen} />}
        />
        {/* <Route path="/growth-chart" element={<GrowthChartScreen />} /> */}

        {/* ✅ NEW: Lab Pick-Up */}
        <Route
          path="/lab-pickup"
          element={<PrivateRoute component={LabPickupPage} />}
        />
        {/* <Route path="/lab-pickup" element={<LabPickupPage />} /> */}
        <Route
          path="/lab-reports-entry"
          element={<PrivateRoute component={LabReportsEntry} />}
        />
        {/* <Route path="/lab-reports-entry" element={<LabReportsEntry />} /> */}
        <Route path="/new-dashboard" element={<NewDashboardPage />} />
      </Route>
    </Routes>
  );
};
